export default __webpack_public_path__ + "static/media/pricing-enterprise.f2dd07e8.jpg";